import type { GuidedTour } from '../types';
import { createTeamTour } from './createTeam.tour';
import { inviteMembersTour } from './inviteMembers.tour';

/**
 * Guided tours launched from the Tutorials page. "Prise en main" is not listed here:
 * it keeps its own engine (auto-start, hover checks), see `steps.ts`.
 */
export const guidedTours: readonly GuidedTour[] = [inviteMembersTour, createTeamTour];

export function findGuidedTour(tourId: string): GuidedTour | undefined {
  return guidedTours.find((tour) => tour.id === tourId);
}

export { createTeamTour, inviteMembersTour };
